import { Users, FolderKanban, Receipt } from "lucide-react";
import BrandMark from "../Brand/BrandMark";
import { AUTH_PANEL_HEIGHT } from "./authFieldStyles";

const FEATURES = [
  {
    icon: Users,
    title: "Vendors and clients",
    body: "Pools, applications, contacts and price lists in one directory.",
  },
  {
    icon: FolderKanban,
    title: "Projects and jobs",
    body: "Follow every job from assignment through to delivery.",
  },
  {
    icon: Receipt,
    title: "Billing that follows the work",
    body: "Receivables, payables, invoices and payments stay linked.",
  },
];

// Brand half of the auth screens. Drawn entirely in CSS so it fits any column
// width, and hidden below lg so the form gets the whole viewport on a phone.
const AuthShowcase = () => (
  // Sticky so a long form (sign up) scrolls past a full height panel instead
  // of stretching it.
  <div
    className={`relative hidden overflow-hidden bg-gradient-to-br from-brand-600 via-brand-700 to-gray-900 lg:sticky lg:top-0 lg:flex lg:flex-col lg:justify-center lg:self-start ${AUTH_PANEL_HEIGHT}`}
  >
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.18]"
      style={{
        backgroundImage:
          "radial-gradient(circle, rgba(255,255,255,0.9) 1px, transparent 1px)",
        backgroundSize: "24px 24px",
      }}
    />

    <div
      aria-hidden="true"
      className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-brand-400/40 blur-3xl"
    />
    <div
      aria-hidden="true"
      className="absolute -bottom-32 -right-16 h-96 w-96 rounded-full bg-brand-500/30 blur-3xl"
    />

    {/* Vertical rhythm stays tight enough to clear a 768px laptop, since the
        panel is a clipped fixed height, and opens up from xl. */}
    <div className="relative px-10 py-12 xl:px-16 xl:py-16">
      <BrandMark size="lg" tone="dark" className="mb-9 xl:mb-11" />

      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-100/80">
        Translation management
      </p>

      <h2 className="mt-4 max-w-md text-[30px] font-semibold leading-[1.15] text-white xl:mt-5 xl:text-[38px]">
        Every project, vendor and invoice in one workspace.
      </h2>

      <p className="mt-4 max-w-sm text-sm leading-relaxed text-brand-100/75 xl:mt-5">
        Globilise keeps the whole pipeline together, so nothing is chased across
        spreadsheets and inboxes.
      </p>

      <ul className="mt-9 max-w-md space-y-6 xl:mt-12 xl:space-y-7">
        {FEATURES.map(({ icon: Icon, title, body }) => (
          <li key={title} className="flex gap-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 ring-1 ring-inset ring-white/20">
              <Icon className="h-5 w-5 text-white" strokeWidth={1.75} />
            </span>
            <div>
              <p className="text-sm font-semibold text-white">{title}</p>
              <p className="mt-1 text-sm leading-relaxed text-brand-100/70">
                {body}
              </p>
            </div>
          </li>
        ))}
      </ul>

      <div className="mt-9 max-w-md border-t border-white/15 pt-5 xl:mt-12 xl:pt-6">
        <p className="text-xs text-brand-100/60">
          Built for translation agencies and freelancers.
        </p>
      </div>
    </div>
  </div>
);

export default AuthShowcase;
